import { useNavigate } from "react-router-dom";
import DataTable from "@/components/common/DataTable";
import Pagination from "@/components/common/Pagination";
import { useActivities } from "@/hooks/useActivities";
import { fmtDate } from "@/lib/format";
import { Activity as ActIcon } from "lucide-react";

export default function ActivityList({ apiParams, type, refreshKey }) {
  const navigate = useNavigate();
  const { items, total, page, setPage, loading, error, reload, pageSize } = useActivities(apiParams, type, 20, refreshKey);
  const columns = [
    { key: "when", label: "When", render: (a) => fmtDate(a.when || a.created_at, true) },
    { key: "type", label: "Type", render: (a) => <span className="font-semibold text-slate-800">{a.type}</span> },
    { key: "lead_name", label: "Lead", render: (a) => a.lead_name || "—" },
    { key: "user_name", label: "By", mobileHide: true },
    { key: "outcome", label: "Outcome", mobileHide: true, render: (a) => a.outcome || "—" },
    { key: "notes", label: "Notes", mobileHide: true, className: "max-w-xs truncate", render: (a) => a.notes || "—" },
  ];
  return (
    <div className="space-y-3" data-testid="activity-list-view">
      <div className="text-sm text-slate-500" data-testid="activity-list-total">{total} activit{total === 1 ? "y" : "ies"}</div>
      <DataTable columns={columns} rows={items} loading={loading} error={error} onRetry={reload} testid="activity-table"
        onRowClick={(a) => a.lead_id && navigate(`/leads/${a.lead_id}`)}
        empty={{ title: "No activities", description: "No calls, visits or notes match these filters.", icon: ActIcon }} />
      <Pagination page={page} pageSize={pageSize} total={total} onPage={setPage} />
    </div>
  );
}
